// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1IdentitySchema = z.object({
  id: z.number().int().gt(0),
  email: z.coerce.string().min(1),
  name: z.coerce.string().min(1),
  time_zone: z.coerce.string().min(1).describe("User timezone identifier (e.g., \"America/New_York\")"),
  updated_at: z.number().int().describe("Last update timestamp (Unix timestamp)"),
  active: z.boolean(),
  deleted: z.boolean(),
  memory_onboarded: z.boolean(),
  day_view_onboarded: z.boolean(),
  last_received_memories_date: z.string().datetime().describe("ISO8601 formatted date").nullish(),
  date_format: z.coerce.string().describe("User preferred date format").nullish(),
  time_format: z.coerce.string().describe("User preferred time format").nullish(),
  memory_retention_days: z.number().int().describe("Number of days to retain memory data").nullish(),
  auth_provider: z.coerce.string().describe("Authentication provider (memory, google, apple, azure_ad, okta)").nullish(),
  avatar: z.object({
    large_retina: z.coerce.string().min(1),
    large: z.coerce.string().min(1),
    medium_retina: z.coerce.string().min(1),
    medium: z.coerce.string().min(1),
    small_retina: z.coerce.string().nullish(),
    small: z.coerce.string().nullish(),
    timeline: z.coerce.string().nullish(),
  }),
  secondary_contacts: z.array(z.object({
    id: z.number().int().gt(0),
    email: z.coerce.string().min(1),
    verified: z.boolean(),
  })).describe("List of linked secondary email addresses"),
});
